// extracted by mini-css-extract-plugin
export default {"modal":"problemModal_modal__yPfT0","form_item_checkbox":"problemModal_form_item_checkbox__eoP0U"};